
import {inject} from 'vue'
export default {
    props:{
       top_searches:{
           type:Array,
           dafault:()=>{}
       },
       onSearchValue:{
           type:Function,
           dafault:()=>{}
       }
    },
  setup(props:any,{emit}:any){
       const $http: any = inject('$http')
       const onHotSearchs = (value:string)=>{          
           emit('onSearchValue',value)
       }
       return {
           onHotSearchs
       }
      
  }
}
